import { Input } from 'reactstrap'

export default function TextInput({ label, name, handleInputChange, defaultValue, value, inputStyle }) {

  if (value || value === '') {
    return (
      <tr>
        <td style={{ verticalAlign: 'middle' }}><b>{label}</b></td>
        <td>
          <Input style={inputStyle} className="custom-input" type='text' name={name} onChange={handleInputChange} value={value} />
        </td>
      </tr>
    )
  }
  return (
    <tr>
      <td style={{ verticalAlign: 'middle' }}><b>{label}</b></td>
      <td>
        <Input style={inputStyle} className="custom-input" type='text' name={name} onChange={handleInputChange} defaultValue={defaultValue} />
      </td>
    </tr>
  )
}
